import
{
    Form2
} from "@ews/react-data";

import
{
    FC
} from "react";

import s from '../SystemDocumentation.module.scss';

const TableForm2: FC<{ data: Form2; }> = ({
    data
}) =>
{
    console.log(data);
    if (!data) return <>no data</>;
    return <table id='system-documentation-form-2' data-name='Formblatt2' className={`${s.table}`} >
        <thead>
            <tr>
                <td style={{ width: "30px" }}></td>
                <td style={{ width: "150px" }}></td>
                <td style={{ width: "80px" }}></td>
                <td style={{ width: "250px" }}></td>
                <td style={{ width: "130px" }}></td>
                <td style={{ width: "230px" }}></td>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td className={`${s.bT} ${s.bL} ${s.bR} ${s.title}`} colSpan={4}>Brandmeldeanlage</td>
                <td className={`${s.b} ${s.title}`} colSpan={4}>TRVB 123 S</td>
            </tr>
            <tr>
                <td className={`${s.bB} ${s.bL} ${s.bR} ${s.title} ${s.bold}`} rowSpan={2} colSpan={4}>Einreichung</td>
                <td className={`${s.bR} ${s.title}`} colSpan={2}>Anhang 1</td>
            </tr>
            <tr>
                <td className={`${s.bR} ${s.title}`} colSpan={2}>Formblatt 2</td>
            </tr>

            <tr>
                <td rowSpan={3} className={`${s.b} ${s.aT} ${s.tL}`}  >11</td>
                <td rowSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Brandmeldesystem</td>

                <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} >Name / Type:</td>
                <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} >BC600</td>
            </tr>
            <tr>
                <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} >Prüfberichtsnummer:</td>
                <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} ></td>
            </tr>
            <tr>
                <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} >Zulassungsnummer:</td>
                <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} ></td>
            </tr>
            {/* PSU */}
            <tr>
                <td rowSpan={9 * data.psus.length + 1} className={`${s.b} ${s.aT} ${s.tL}`}  >12</td>
                <td rowSpan={9 * data.psus.length + 1} className={`${s.b} ${s.aT} ${s.tL}`} >Stromversorgung</td>

                <td colSpan={4} className={`${s.b} ${s.aT} ${s.tL}`} >Netzteile der Brandmeldezentralen</td>

            </tr>
            {data.psus && data.psus.length > 0 && data.psus.map((psu, idx) => (
                <>
                    <tr>
                        <td colSpan={1} rowSpan={9} className={`${s.b} ${s.aT} ${s.tL}`} >{idx + 1}</td>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Montageort</td>
                        <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} >{psu.installationLocation}</td>
                    </tr>
                    <tr>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Netzteiltyp</td>
                        <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} >{psu.powerSupplyType}</td>
                    </tr>
                    <tr>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Nennstrom (A): </td>
                        <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} >{psu.ratedCurrent}</td>
                    </tr>
                    <tr>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Stromaufnahme bei Netzstörung: </td>
                        <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} ></td>
                    </tr>
                    <tr>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Maximale Stromaufnahme im Brandalarmzustand (mA): </td>
                        <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} >{psu.fireAlarmCurrent}</td>
                    </tr>
                    <tr>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Notstrombatterie Nennspannung (V): </td>
                        <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} >{psu.batteryVoltage}</td>
                    </tr>
                    <tr>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Notstrombatterie Kapazität (Ah): </td>
                        <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} >{psu.batteryCapacity}</td>
                    </tr>
                    <tr>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Anzahl der Notstrombatterien: </td>
                        <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} >{psu.count}</td>
                    </tr>
                    <tr>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Nennspannung der sekundären Energieversorgung: </td>
                        <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} >{psu.secondaryVoltage}</td>
                    </tr>
                </>
            ))}
            <tr>
                <td rowSpan={8 * data.centralPanels.length + 1} className={`${s.b} ${s.aT} ${s.tL}`}  >13</td>
                <td rowSpan={8 * data.centralPanels.length + 1} className={`${s.b} ${s.aT} ${s.tL}`} >Zentralen</td>
            </tr>
            {data.centralPanels && data.centralPanels.length > 0 && data.centralPanels.map((panel, idx) => (
                <>
                    <tr>
                        <td colSpan={1} rowSpan={8} className={`${s.b} ${s.aT} ${s.tL}`} >{idx + 1}</td>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Standort:</td>
                        <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} >{panel.location}</td>
                    </tr>
                    <tr>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Type:</td>
                        <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} >{panel.type}</td>
                    </tr>
                    <tr>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Bediengruppen:</td>
                        <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} >{panel.controlGroups}</td>
                    </tr>
                    <tr>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Eingänge</td>
                        <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} >{panel.inputs}</td>
                    </tr>
                    <tr>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Übertragungseinrichtungen: </td>
                        <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} >{panel.transmissionDevices}</td>
                    </tr>
                    <tr>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Alarmierungseinrichtungen: </td>
                        <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} >{panel.alarmingDevices}</td>
                    </tr>
                    <tr>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Steuerungen: </td>
                        <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} >{panel.actuations}</td>
                    </tr>
                    <tr>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Prüfberichtsnummer: </td>
                        <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} >{panel.testReportNumber}</td>
                    </tr>
                </>
            ))}
            <tr>
                <td rowSpan={3} className={`${s.b} ${s.aT} ${s.tL}`}  >14</td>
                <td rowSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Parallelanzeige einrichtungen</td>
                <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} ></td>
                <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Standort:</td>
                <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} ></td>
            </tr>
            <tr>
                <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} ></td>
                <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Type:</td>
                <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} ></td>
            </tr>
            <tr>
                <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} ></td>
                <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Angeschlossen an:</td>
                <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} ></td>
            </tr>
            <tr>
                <td rowSpan={3} className={`${s.b} ${s.aT} ${s.tL}`}  ></td>
                <td rowSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Feuerwehrbedienfeld</td>
                <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} ></td>
                <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Standort:</td>
                <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} ></td>
            </tr>
            <tr>
                <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} ></td>
                <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Type:</td>
                <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} ></td>
            </tr>
            <tr>
                <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} ></td>
                <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Angeschlossen an:</td>
                <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} ></td>
            </tr>
            {data.detachedControlPanel && data.detachedControlPanel.length > 0 && data.detachedControlPanel.map((panel, idx) => (
                <>   <tr>
                    <td rowSpan={3} className={`${s.b} ${s.aT} ${s.tL}`}  ></td>
                    <td rowSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Abgesetztes Bedienfeld</td>
                    <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >{idx}</td>
                    <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Standort:</td>
                    <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} >{panel.location}</td>
                </tr>
                    <tr>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} ></td>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Type:</td>
                        <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} >{panel.type}</td>
                    </tr>
                    <tr>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} ></td>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Angeschlossen an:</td>
                        <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} >{panel.connectedTo}</td>
                    </tr>
                </>))}
            <tr>
                <td rowSpan={1 + data.automaticFireDetectors.length} className={`${s.b} ${s.aT} ${s.tL}`}  >15</td>
                <td rowSpan={1 + data.automaticFireDetectors.length} className={`${s.b} ${s.aT} ${s.tL}`} >Automatische Brandmelder</td>
                <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Stück</td>
                <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Art</td>
                <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} >Type</td>
            </tr>
            {data.automaticFireDetectors && data.automaticFireDetectors.map((detector, idx) => (
                <tr>

                    <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >{detector.count}</td>
                    <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >{detector.kind}</td>
                    <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} >{detector.type}</td>

                </tr>
            ))}
            <tr>
                <td rowSpan={1 + data.manualFireDetectors.length} className={`${s.b} ${s.aT} ${s.tL}`}  >16</td>
                <td rowSpan={1 + data.manualFireDetectors.length} className={`${s.b} ${s.aT} ${s.tL}`} >Handfeuermelder</td>
                <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Stück</td>
                <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Art</td>
                <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} >Type</td>
            </tr>
            {data.manualFireDetectors && data.manualFireDetectors.map((detector, idx) => (
                <tr>

                    <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >{detector.count}</td>
                    <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >{detector.kind}</td>
                    <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} >{detector.type}</td>

                </tr>
            ))}
        </tbody>
    </table>;
};

export default TableForm2;
